export function getView(selected) {
  return selected ? 'Content' : 'Empty'
}
